import { LandLineProcedureInterface } from '../../models/land-line-procedure.interface';

export interface LandLineProcedureInterfaceState {
  landLineProcedures: Array<LandLineProcedureInterface>;
}

export const initialLandLineProcedureState: LandLineProcedureInterfaceState = {
  landLineProcedures: null
};
